var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", [
    _c("div", [
      _vm.showLoading ? _c("div", { staticClass: "jleague_loader" }) : _vm._e(),
      _vm._v(" "),
      !_vm.showLoading
        ? _c("div", [
            !_vm.isClubSelected
              ? _c(
                  "div",
                  [
                    _c("SelectClub", {
                      attrs: {
                        favoritePlayerList: _vm.favoritePlayerList,
                        selectedClubCodes: _vm.selectedClubCodes,
                      },
                      on: { "club-selected": _vm.handleClubSelection },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isClubSelected
              ? _c(
                  "div",
                  [
                    _c("SelectFavoritePlayer", {
                      attrs: {
                        selectedClubCode: _vm.selectedClubCode,
                        favoritePlayerList: _vm.favoritePlayerList,
                        accessToken: _vm.accessToken,
                        selectedClubCodes: _vm.selectedClubCodes,
                      },
                      on: { "change-view": _vm.handleViewChange },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }